import { put, takeEvery, call } from 'redux-saga/effects';

import {
  RESET_NEW_PASSWORD_SEND, resetNewPasswordSetSent
} from 'src/app/redux/actions/reset/resetNewPasswordSend';
import alerts from 'src/app/alerts.json';
import getWindowSearchParam from 'src/app/api/getWindowSearchParam';
import { resetNewPasswordSetApiError } from 'src/app/redux/actions/reset/resetNewPassword';
import { feedbackMessageHide, feedbackMessageShow } from 'src/app/redux/actions/feedbackMessage';
import resetApi from 'src/app/api/resetApi';
import { apiErrorSetPassword } from 'src/app/redux/actions/apiError';


// eslint-disable-next-line max-params
function sendNewPassword(userId, token, setNewPasswordRequest, passwordChangedSuccess) {
  return function* sendNewPasswordGenerator ({ payload }) {

    yield put(resetNewPasswordSetApiError(false));
    yield put(feedbackMessageHide());

    const sendNewPasswordRequest = yield setNewPasswordRequest({ password: payload, token, userId })
      .then(function* onSuccess() {
        yield put(resetNewPasswordSetSent(true));
        return yield put(feedbackMessageShow(passwordChangedSuccess));
      })
      .catch(function* onError({ response }) {
        yield put(resetNewPasswordSetApiError(true));

        return yield put(apiErrorSetPassword(response));
      });

    yield call(() => sendNewPasswordRequest);
  };
}

export default [
  takeEvery(RESET_NEW_PASSWORD_SEND, sendNewPassword(
      getWindowSearchParam('userId'),
      getWindowSearchParam('token'),
      resetApi.setNewPassword,
      alerts.passwordChangedSuccess
    )
  )
];
